import React, { useEffect, useState } from 'react'
import { CCard, CCardBody, CFormText, CProgress, CProgressBar, CTooltip } from '@coreui/react'
import { formatBytes, formatFileName } from 'src/views/utils/helper'
import axios from 'axios'
import { getPresignedPostUrl, updateJobStatus } from 'src/s3upload/upload-file'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheckCircle,
  faExclamationCircle,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons'
import { MAX_UPLOAD_SIZE } from 'src/views/utils/constants'
import InfoButton from '../../assets/infoButton.png'

let CANCEL_UPLOAD = {}

const FileUploadCard = ({
  fileInfo,
  uploadData,
  onComplete,
  onFailed,
  triggerCancel,
  uploadSpeed,
}) => {
  const accountId = localStorage.getItem('accountId')
  const [completePercentage, setCompletePercentage] = useState(0)
  const [assetId, setAssetId] = useState('')
  const [cancelTooltip, setCancelTooltip] = useState('')

  useEffect(() => {
    if (uploadData?.jobId) {
      CANCEL_UPLOAD[`${uploadData.assetId}`] = false

      if (fileInfo.size > MAX_UPLOAD_SIZE) {
        handleCancelUpload(`Size Greater than ${formatBytes(MAX_UPLOAD_SIZE)}!`)
        handleFailedJobStatus()
        return
      }
      setAssetId(uploadData.assetId)
      handleUpload(uploadData)
    }
  }, [uploadData])

  useEffect(() => {
    if (triggerCancel) {
      handleCancelUpload()
    }
  }, [triggerCancel])

  const handleCancelUpload = (message) => {
    CANCEL_UPLOAD[`${assetId}`] = true
    setCancelTooltip(typeof message === 'string' ? message : 'Cancelled by User!')
    if (!triggerCancel) {
      setCompletePercentage(-1)
    }
  }

  const handleUpload = async (uploadData) => {
    let successCount = 0
    let ETagMap = {}
    let jobData = {}

    for (let idx = 0; idx < uploadData.chunks.length; idx++) {
      if (CANCEL_UPLOAD[`${uploadData.assetId}`]) {
        break
      }
      const uploadChunk = uploadData.chunks[idx]
      const AWSUploadResponse = await axios.put(uploadData.signedURLObj[idx + 1], uploadChunk)

      if (!CANCEL_UPLOAD[`${uploadData.assetId}`] && AWSUploadResponse.status === 200) {
        successCount++

        const reductionValue = fileInfo.size > 100000 ? 100000 : fileInfo.size / 10

        setCompletePercentage(
          (completePercentage) =>
            (completePercentage += ((uploadChunk.size - reductionValue) / fileInfo.size) * 100),
        )
        ETagMap[`${idx + 1}`] = AWSUploadResponse.headers?.etag
      }
    }

    if (!CANCEL_UPLOAD[`${uploadData.assetId}`] && successCount === uploadData.chunks.length) {
      jobData[`${uploadData.assetId}`] = { status: 'SUCCESS', etag_map: ETagMap }

      const jobUpdateRes = await updateJobStatus(jobData, uploadData.jobId, accountId)
      if (!CANCEL_UPLOAD[`${uploadData.assetId}`] && jobUpdateRes.success) {
        setCompletePercentage(100)
        onComplete()
      } else {
        setCancelTooltip('Something went Wrong!')
        setCompletePercentage(-1)
        onFailed(+1)
      }
    } else {
      handleFailedJobStatus()
    }
  }

  const handleFailedJobStatus = async () => {
    setCompletePercentage(-1)
    onFailed(+1)
    let jobData = {}
    jobData[`${uploadData.assetId}`] = { status: 'FAILED' }
    await updateJobStatus(jobData, uploadData.jobId, accountId)
  }

  const handleRetryUpload = async () => {
    if (fileInfo.size > MAX_UPLOAD_SIZE) {
      return
    }
    const tempFileName = formatFileName(fileInfo.name)
    const signedURLRes = await getPresignedPostUrl({
      customer_id: accountId,
      upload_type: 'FROM_DEVICE',
      assets: [
        {
          ...uploadData.signedURLPayload,
          file_name: tempFileName,
        },
      ],
    })

    if (signedURLRes?.success) {
      setAssetId(signedURLRes.data[`${tempFileName}`].asset_id)
      CANCEL_UPLOAD[`${uploadData.assetId}`] = false
      CANCEL_UPLOAD[`${signedURLRes.data[`${tempFileName}`].asset_id}`] = false
      setCompletePercentage(0)
      onFailed(-1)
      let retryUploadData = {
        signedURLObj: signedURLRes.data[`${tempFileName}`].signed_url_dict,
        chunks: uploadData.chunks,
        assetId: signedURLRes.data[`${tempFileName}`].asset_id,
        s3Key: signedURLRes.data[`${tempFileName}`].s3_key,
        jobId: signedURLRes.data[`job_id`],
      }
      handleUpload(retryUploadData)
    }
  }
  const fileName = fileInfo.name.length > 40 ? fileInfo.name.slice(0, 40) + '...' : fileInfo.name

  const secondsToHms = (d) => {
    d = Number(d)
    var h = Math.floor(d / 3600)
    var m = Math.floor((d % 3600) / 60)
    var s = Math.ceil((d % 3600) % 60)

    var hDisplay = h > 0 ? h + (h === 1 ? ' hour, ' : ' hours, ') : ''
    var mDisplay = m > 0 ? m + (m === 1 ? ' minute, ' : ' minutes, ') : ''
    var sDisplay = s > 0 ? s + (s === 1 ? ' second' : ' seconds') : ''
    return hDisplay + mDisplay + sDisplay
  }

  const calculateRemainingTime = () => {
    const uploadedBytes = fileInfo.size * (completePercentage / 100)
    const timeInSec = (fileInfo.size - uploadedBytes) / uploadSpeed.bps
    console.log('timeInSec', timeInSec)
    return uploadSpeed.bps > 0 && timeInSec > 0
      ? '     .    ' + secondsToHms(timeInSec) + ' left'
      : ''
  }

  return (
    <CCard
      className="my-3"
      style={{
        backgroundColor: '#fff',
        boxShadow: ' 4px 4px 6px 0 rgba(0, 0, 0, 0.16)',
      }}
    >
      <CCardBody>
        <div
          className=" d-flex justify-content-center align-items-center"
          //   style={{
          //     minHeight: `${completePercentage === 100 || completePercentage < 0 ? '80px' : '70px'}`,
          //   }}
        >
          <div className="" style={{ width: '95%' }}>
            <div className="d-flex justify-content-between">
              <div className="d-flex">
                {fileName}
                <CFormText
                  className="mx-3"
                  style={{
                    color: `${
                      completePercentage === 100 ? '#4caf50' : completePercentage < 0 ? 'red' : ''
                    }`,
                  }}
                >
                  {completePercentage === 100
                    ? 'completed'
                    : completePercentage < 0
                    ? 'Failed'
                    : 'is uploading ...'}
                </CFormText>
                {completePercentage < 0 && (
                  <div>
                    <CTooltip content={`${cancelTooltip}`} placement="top">
                      <img
                        src={InfoButton}
                        alt="InfoButton"
                        style={{ height: '1rem', width: '1rem', cursor: 'pointer' }}
                      />
                    </CTooltip>
                  </div>
                )}
              </div>
              {completePercentage === 100 && (
                <CFormText className="mx-1">{`${formatBytes(fileInfo.size)}`}</CFormText>
              )}
              {0 <= completePercentage && completePercentage < 100 && uploadSpeed.mbps > 0 && (
                <CFormText className="mx-1">{`${uploadSpeed.mbps} mbps`}</CFormText>
              )}
              {fileInfo.size < MAX_UPLOAD_SIZE && completePercentage < 0 && (
                <CFormText
                  style={{ color: '#1147f8', cursor: `pointer` }}
                  className="mx-1"
                  onClick={handleRetryUpload}
                >{`Re-try`}</CFormText>
              )}
            </div>
            {0 <= completePercentage && completePercentage < 100 ? (
              <div>
                <div>
                  <CProgress className="mt-1">
                    <CProgressBar
                      color="info"
                      //   style={{ height: '.75rem' }}
                      animated
                      value={completePercentage}
                    />
                  </CProgress>
                </div>
                <div className="d-flex justify-content-between">
                  <div className="d-flex">
                    <CFormText className="">{completePercentage.toFixed(2)}% </CFormText>
                    <CFormText className="">{calculateRemainingTime()}</CFormText>
                  </div>
                  <CFormText className="">
                    {`${formatBytes(
                      parseInt(fileInfo.size * (completePercentage / 100)),
                    )} of ${formatBytes(fileInfo.size)}`}
                  </CFormText>
                </div>
              </div>
            ) : null}
          </div>
          <div style={{ width: '5%' }} className="d-flex justify-content-center align-items-center">
            {completePercentage === 100 ? (
              <FontAwesomeIcon
                icon={faCheckCircle}
                size="xl"
                style={{
                  color: '#4caf50',
                  fontSize: '1.5rem',
                }}
                title="Completed"
              />
            ) : completePercentage < 0 ? (
              <FontAwesomeIcon
                icon={faExclamationCircle}
                style={{
                  color: 'red',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                }}
                onClick={handleRetryUpload}
                title="Failed"
              />
            ) : (
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={{
                  color: 'gray',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                }}
                onClick={handleCancelUpload}
                title="Cancel"
              />
            )}
          </div>
        </div>
      </CCardBody>
    </CCard>
  )
}

export default FileUploadCard
